import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import VehiclePopUpInfo from '../vehiclePopUpInfo/PopUpInfo';
import { OverlayView, Marker } from '@react-google-maps/api';
import NearMeIcon from '@material-ui/icons/NearMe';
import config from '../../../config';

var MarkerVehicle2 = function (_Component) {
    _inherits(MarkerVehicle2, _Component);

    function MarkerVehicle2(props) {
        _classCallCheck(this, MarkerVehicle2);

        var _this = _possibleConstructorReturn(this, (MarkerVehicle2.__proto__ || Object.getPrototypeOf(MarkerVehicle2)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            position: {
                lat: _this.props.position.lat,
                lng: _this.props.position.lng
            },
            clusterer: _this.props.clusterer,
            isShown: true,
            class1: '',
            PopUpDeviceInfo: React.createElement(VehiclePopUpInfo, null),
            popUpInfo: false,
            historical: false,
            actualHistorical: true,
            popUpHistorical: false,
            expandedDevice: false,
            address: undefined,
            historicalData: '',
            listHistoricalData: [],
            mode: -1,
            stopDataIndividually: false,
            dataStop: "",
            count: -1,
            layerDevice: '',
            isShown1: ''
        };

        return _this;
    }

    /* se invoca justo antes de llamar al método de render, 
    tanto en la montura inicial como en las actualizaciones posteriores. 
    Debes devolver un objeto para actualizar el estado, o nulo para actualizar nada. */


    // componentDidMount() {
    //     this.setState({
    //         isShown: false
    //     });
    // }

    _createClass(MarkerVehicle2, [{
        key: 'msToTime',
        value: function msToTime(duration) {

            var minutes = Math.floor(duration / (1000 * 60) % 60),
                hours = Math.floor(duration / (1000 * 60 * 60) % 24);

            hours = hours < 10 ? "0" + hours : hours;
            minutes = minutes < 10 ? "0" + minutes : minutes;

            var styleClass = "";

            if (hours >= 8) {
                styleClass = "numberGreen";
            } else if (hours <= 8 && minutes >= 45) {
                styleClass = "numberRed";
            } else {
                styleClass = "numberGray";
            }

            var resultArray = [hours + ":" + minutes, styleClass];
            return resultArray;
        }
    }, {
        key: 'getAddress',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lat, lng) {
                var address, response;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(lat !== 0)) {
                                    _context.next = 14;
                                    break;
                                }

                                lat = lat.toString();
                                lng = lng.toString();

                                _context.next = 5;
                                return fetch(config.URL + ('maps?lat=' + lat + '&lon=' + lng));

                            case 5:
                                address = _context.sent;

                                if (!address.ok) {
                                    _context.next = 13;
                                    break;
                                }

                                _context.next = 9;
                                return address.text();

                            case 9:
                                response = _context.sent;
                                return _context.abrupt('return', response);

                            case 13:
                                alert("HTTP-Error: " + address.status);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getAddress(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return getAddress;
        }()
    }, {
        key: 'render',
        value: function render() {
            var angle = this.props.angle - 45;
            var name = this.props.name;


            var setPosition = {
                margin: "2px 1px",
                color: "#68b32e",
                transform: 'rotate(' + angle + 'deg)'

            };

            var circle = void 0;

            if (this.state.class1 === "map-location-4") {
                circle = React.createElement(
                    'div',
                    { id: 'h', style: setPosition, className: '' },
                    React.createElement(
                        'i',
                        { className: 'fas fa-location-arrow' },
                        React.createElement(NearMeIcon, null)
                    )
                );
            } else {
                circle = React.createElement(
                    'div',
                    { className: 'outer circle shapeborder' },
                    React.createElement(
                        'div',
                        { className: 'inner circle shapeborder' },
                        '\xA0'
                    )
                );
            }
            return this.props.isVehicleGrouped === false ? React.createElement(
                Marker,
                {
                    position: this.state.position,
                    clusterer: this.state.clusterer
                    // icon={{path: 'google.maps.SymbolPath.CIRCLE', scale: 0}}
                    , icon: { path: '' }
                },
                this.state.isShown && React.createElement(
                    OverlayView,
                    {
                        key: Math.random(),
                        position: this.state.position,
                        mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
                        getPixelPositionOffset: this.getPixelPositionOffset

                    },
                    React.createElement(
                        'div',
                        { style: { position: "absolute", top: "0px", right: "-30px" } },
                        React.createElement(
                            'div',
                            { className: this.state.class1 + " map-locator js-category-filterable " + this.state.label },
                            React.createElement(
                                'button',
                                { onClick: this.props.closePopUpDeviceInfo.bind(function (event) {
                                        return event;
                                    }, this.props.device) },
                                React.createElement(
                                    'ul',
                                    { className: 'list-unstyled' },
                                    React.createElement(
                                        'li',
                                        null,
                                        circle
                                    ),
                                    React.createElement(
                                        'li',
                                        null,
                                        name
                                    )
                                )
                            )
                        )
                    )
                )
            ) : React.createElement(
                Marker,
                {
                    position: this.state.position,
                    clusterer: this.state.clusterer,
                    visible: false,
                    onVisibleChanged: this.showMarkerContent
                    // icon={{path: 'google.maps.SymbolPath.CIRCLE', scale: 0}}
                    , icon: { path: '' }
                },
                this.state.isShown && React.createElement(
                    OverlayView,
                    {
                        key: Math.random(),
                        position: this.state.position,
                        mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
                        getPixelPositionOffset: this.getPixelPositionOffset

                    },
                    React.createElement(
                        'div',
                        { style: { position: "absolute", top: "0px", right: "-30px" } },
                        React.createElement(
                            'div',
                            { className: this.state.class1 + " map-locator js-category-filterable " + this.state.label },
                            React.createElement(
                                'button',
                                { onClick: this.props.closePopUpDeviceInfo.bind(function (event) {
                                        return event;
                                    }, this.props.device) },
                                React.createElement(
                                    'ul',
                                    { className: 'list-unstyled' },
                                    React.createElement(
                                        'li',
                                        null,
                                        circle
                                    ),
                                    React.createElement(
                                        'li',
                                        null,
                                        name
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return MarkerVehicle2;
}(Component);

MarkerVehicle2.getDerivedStateFromProps = function (props, state) {
    var _ref2 = '',
        class1 = _ref2.class1,
        label = _ref2.label,
        isShown = _ref2.isShown;
    // if (props.speed >= 5) {
    //     class1 = 'map-location-4';
    //     label = 'Driving';
    // }
    // if (props.speed >= 1 && props.speed < 5) {
    //     class1 = 'map-location-5';
    //     label = 'Stop';
    // }
    // if (props.speed === 0) {
    //     class1 = 'map-location-2';
    //     label = 'Parking';
    // }

    if (props.tag === "Circulando") {
        class1 = 'map-location-4';
        label = 'Driving';
    }
    if (props.tag === "Parado") {
        class1 = 'map-location-5';
        label = 'Stop';
    }
    if (props.tag === "Estacionado") {
        class1 = 'map-location-2';
        label = 'Parking';
    }
    if (props.tag === "NoGprs") {
        class1 = 'map-location-6';
        label = 'NoGprs';
    }
    if (props.tag === "NoGps") {
        class1 = 'map-location-1';
        label = 'NoGps';
    }
    if (props.tag === "NoInstalacion") {
        class1 = 'map-location-8';
        label = 'noInstalacion';
    }
    // if (props.clusterer.map.zoom >10 && props.markersDisplay) {
    //     isShown = true
    // } else {
    //     isShown = false
    // }


    return {
        position: {
            lat: props.position.lat,
            lng: props.position.lng
        },
        class1: class1,
        label: label,
        layerDevice: props.layerDevice

    };
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.showMarkerContent = function () {
        _this2.setState({
            isShown: !_this2.state.isShown
        });
    };

    this.getPixelPositionOffset = function (width, height) {
        return {
            x: -(width / 2),
            y: -(height / 2)

        };
    };

    this.handleOnClick = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
            var location;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            e.preventDefault();
                            e.stopPropagation();

                            if (!(_this2.state.popUpInfo === false)) {
                                _context2.next = 9;
                                break;
                            }

                            _context2.next = 5;
                            return _this2.getAddress(_this2.state.position.lat, _this2.state.position.lng);

                        case 5:
                            location = _context2.sent;

                            _this2.setState({
                                popUpInfo: !_this2.state.popUpInfo,
                                address: location,
                                popUpHistorical: false

                            });
                            _context2.next = 10;
                            break;

                        case 9:
                            _this2.setState({
                                popUpInfo: false,
                                historical: false
                            });

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();

    this.handleOnClickHistoricalToday = function (mode) {
        // console.log(jsonHistoricalData)

        _this2.setState({
            historical: true,
            popUpHistorical: !_this2.state.popUpHistorical,
            actualHistorical: false,
            popUpInfo: false,
            mode: mode
        }, function () {
            return _this2.getHistorical();
        });
    };

    this.handleOnClickHistoricalYesterday = function (mode) {

        // console.log(jsonHistoricalData)

        _this2.setState({
            historical: true,
            popUpHistorical: !_this2.state.popUpHistorical,
            actualHistorical: false,
            popUpInfo: false,
            mode: mode
        }, function () {
            return _this2.getHistorical();
        });
    };

    this.handleOnClickBackHistorical = function (e) {
        e.preventDefault();

        _this2.setState({
            popUpInfo: true,
            historical: false,
            popUpHistorical: false,
            actualHistorical: true
        });
    };

    this.closePopUpHistorical = function () {
        _this2.setState({
            popUpInfo: false,
            historical: false,
            actualHistorical: true,
            popUpHistorical: false,
            expandedDevice: false
        });
    };

    this.getHistorical = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var jsonHistoricalData, resposeHistoricalData, jsonListHistoricalData, resposeListHistoricalData, str, i, date, hours, duration, styleClass, maxDuration, _hours, _duration, _styleClass, _maxDuration;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        jsonHistoricalData = "";
                        _context3.next = 3;
                        return fetch(_this2.props.urlApi + "HistoricalData/SummaryTrip?VehicleId=" + _this2.props.device.id + "&mode=" + _this2.state.mode, {
                            headers: {
                                'accessToken': _this2.props.accessToken
                            }
                        });

                    case 3:
                        resposeHistoricalData = _context3.sent;

                        if (!resposeHistoricalData.ok) {
                            _context3.next = 10;
                            break;
                        }

                        _context3.next = 7;
                        return resposeHistoricalData.json();

                    case 7:
                        jsonHistoricalData = _context3.sent;
                        _context3.next = 11;
                        break;

                    case 10:
                        alert("HTTP-Error: " + resposeHistoricalData.status);

                    case 11:
                        jsonListHistoricalData = "";
                        _context3.next = 14;
                        return fetch(_this2.props.urlApi + "HistoricalData/StopsTrip?VehicleId=" + _this2.props.device.id + "&mode=" + _this2.state.mode, {
                            headers: {
                                'accessToken': _this2.props.accessToken
                            }
                        });

                    case 14:
                        resposeListHistoricalData = _context3.sent;

                        if (!resposeListHistoricalData.ok) {
                            _context3.next = 21;
                            break;
                        }

                        _context3.next = 18;
                        return resposeListHistoricalData.json();

                    case 18:
                        jsonListHistoricalData = _context3.sent;
                        _context3.next = 22;
                        break;

                    case 21:
                        alert("HTTP-Error: " + resposeListHistoricalData.status);

                    case 22:

                        // for (let i = 0; i < jsonHistoricalData.length; i++) {

                        //     jsonHistoricalData[i] = {
                        //         drivingTime: jsonHistoricalData[i].drivingTime,
                        //         stopTime: jsonHistoricalData[i].stopTime,
                        //         distanceTravelled: jsonHistoricalData[i].distanceTravelled.replace(",", "."),
                        //         fuelConsumption: jsonHistoricalData[i].fuelConsumption
                        //     }

                        // }
                        str = jsonHistoricalData.distanceTravelled.toString();

                        str = str.replace(".", ",");
                        jsonHistoricalData.distanceTravelled = str;

                        for (i = 0; i < jsonListHistoricalData.length; i++) {

                            if (jsonListHistoricalData[i].stopTime === 0) {
                                date = new Date();
                                hours = Math.abs(date.getTime() - _this2.calcDuration(jsonListHistoricalData[i].startTime)) / 36e5;
                                // console.log(hours);

                                hours = hours.toString();

                                duration = hours.split(".");

                                duration[1] = duration[1] * 60;
                                duration[1] = duration[1].toString().substr(0, 2);
                                // console.log(duration[1])
                                // .toString().substr(0,2);


                                styleClass = "";


                                if (duration[0] >= 8) {
                                    styleClass = "numberGreen";
                                } else if (duration[0] <= 8 && duration[1] >= 45) {
                                    styleClass = "numberRed";
                                } else {
                                    styleClass = "numberGray";
                                }

                                if (duration[0] < 10) {
                                    duration[0] = "0" + duration[0];
                                }

                                maxDuration = [duration[0] + ":" + duration[1], styleClass];


                                jsonListHistoricalData[i] = {
                                    address: jsonListHistoricalData[i].address,
                                    latitude: jsonListHistoricalData[i].latitude,
                                    longitude: jsonListHistoricalData[i].longitude,
                                    startTime: _this2.transformDate(jsonListHistoricalData[i].startTime),
                                    stopTime: 0,
                                    duration: maxDuration[0],
                                    styleClass: maxDuration[1],
                                    vehicleId: jsonListHistoricalData[i].vehicleId
                                };
                            } else {
                                _hours = (_this2.calcDuration(jsonListHistoricalData[i].stopTime) - _this2.calcDuration(jsonListHistoricalData[i].startTime)) / 36e5;

                                _hours = _hours.toString();

                                _duration = _hours.split(".");

                                _duration[1] = _duration[1] * 60;
                                _duration[1] = _duration[1].toString().substr(0, 2);

                                // .toString().substr(0,2);


                                _styleClass = "";


                                if (_duration[0] >= 8) {
                                    _styleClass = "numberGreen";
                                } else if (_duration[0] <= 8 && _duration[1] >= 45) {
                                    _styleClass = "numberRed";
                                } else {
                                    _styleClass = "numberGray";
                                }

                                if (_duration[0] < 10) {
                                    _duration[0] = "0" + _duration[0];
                                }

                                _maxDuration = [_duration[0] + ":" + _duration[1], _styleClass];
                                // let maxDuration = this.msToTime(diffMilliseconds);

                                jsonListHistoricalData[i] = {
                                    address: jsonListHistoricalData[i].address,
                                    latitude: jsonListHistoricalData[i].latitude,
                                    longitude: jsonListHistoricalData[i].longitude,
                                    startTime: _this2.transformDate(jsonListHistoricalData[i].startTime),
                                    stopTime: _this2.transformDate(jsonListHistoricalData[i].stopTime),
                                    duration: _maxDuration[0],
                                    styleClass: _maxDuration[1],
                                    vehicleId: jsonListHistoricalData[i].vehicleId
                                };
                            }
                        }

                        _this2.setState({
                            historicalData: jsonHistoricalData,
                            listHistoricalData: jsonListHistoricalData
                        });

                    case 27:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this2);
    }));

    this.calcDuration = function (ticks) {
        var epochTicks = 621355968000000000;

        // console.log(ticks)
        // console.log(epochTicks)
        var ticksPerMillisecond = 10000;
        var ticksSinceEpoch = ticks - epochTicks;

        var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

        var date = new Date(millisecondsSinceEpoch);
        return date;
    };

    this.transformDate = function (ticks) {

        var epochTicks = 621355968000000000;

        var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        var ticksPerMillisecond = 10000;
        var ticksSinceEpoch = ticks - epochTicks;

        var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

        var date = new Date(millisecondsSinceEpoch);

        var day = date.getDate();
        if (day < 10) {
            day = "0" + day;
        }

        var month = date.getMonth();
        month = months[month];
        if (month < 10) {
            month = "0" + month;
        }

        var year = date.getFullYear();

        var hours = date.getHours();

        var minutes = date.getMinutes();

        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (hours < 10) {
            hours = "0" + hours;
        }

        var resultDate = [hours + ":" + minutes, day + "/" + month + "/" + year];
        return resultDate;
    };

    this.handleOnClickPopUpHistorical = function (e) {
        e.preventDefault();
        _this2.setState({
            popUpHistorical: !_this2.state.popUpHistorical
        });
    };

    this.checkIsExpandedContentDevice = function () {
        _this2.setState({
            expandedDevice: !_this2.state.expandedDevice
        });
    };

    this.showStopIndividually = function (dataStop, i) {
        _this2.setState({
            stopDataIndividually: true,
            historical: false,
            dataStop: dataStop,
            count: i
        });
    };

    this.backStopIndividually = function () {
        _this2.setState({
            stopDataIndividually: false,
            historical: true
        }, function () {
            _this2.props.createMarkerHistoricalStopsIndividually();
        });
    };
};

export default MarkerVehicle2;